export default "__VITE_ASSET__QzjlFOzP__"